import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	PUT_TITLE: type('[ConfirmModal] putTitle '),
	PUT_CONFIRM: type('[ConfirmModal] putConfirm'),
	PUT_BODY_MSG: type('[ConfirmModal] putBodyMsg'),
	PUT_OK_LABEL: type('[ConfirmModal] PutOkLabel'),
	PUT_CANCEL_LABEL: type('[ConfirmModal] PutCancelLabel'),
	PUT_IS_ACCENT:type('[ConfirmModal] PutIsAccent'),
	RESET: type('[ConfirmModal] Reset')
};

export class PutTitle implements Action {
	type = ActionTypes.PUT_TITLE;

	/**
	 *Creates an instance of PutTitle.
	 * @param {*} [payload]
	 * @memberof PutTitle
	 */
	constructor(public payload: string) { }
}

export class PutBodyMsg implements Action {
	type = ActionTypes.PUT_BODY_MSG;

	/**
	 *Creates an instance of PutTitle.
	 * @param {*} [payload]
	 * @memberof PutBodyMsg
	 */
	constructor(public payload: string) { }
}

export class PutOkLabel implements Action {
	type = ActionTypes.PUT_OK_LABEL;

	/**
	 *Creates an instance of PutTitle.
	 * @param {*} [payload]
	 * @memberof PutOkLabel
	 */
	constructor(public payload: string) { }
}

export class PutCancelLabel implements Action {
	type = ActionTypes.PUT_CANCEL_LABEL;

	/**
	 *Creates an instance of PutTitle.
	 * @param {*} [payload]
	 * @memberof PutCancelLabel
	 */
	constructor(public payload: string) { }
}

export class PutConfirm implements Action {
	type = ActionTypes.PUT_CONFIRM;

	/**
	 *Creates an instance of PutConfirm.
	 * @param {*} payload
	 * @memberof PutConfirm
	 */
	constructor(public payload: string) { }
}

export class PutIsAccent implements Action {
	type = ActionTypes.PUT_IS_ACCENT;

	/**
	 *Creates an instance of PutIsAccent.
	 * @param {*} payload
	 * @memberof PutIsAccent
	 */
	constructor(public payload: boolean) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions = PutTitle | PutBodyMsg | PutOkLabel | PutConfirm | PutIsAccent | ResetAction;
